module.exports = __webpack_public_path__ + "static/media/postgresql-logo.ebe57d31.svg";